import { Elements as StripeProvider } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';

import type { ManageAccountModel } from '@models/account';

import ChangePaymentForm from './ChangePaymentForm';

interface PaymentInfoProps {
  account?: ManageAccountModel;
  loading: boolean;
}

const ChangePaymentInfo: React.FC<PaymentInfoProps> = ({
  account,
  loading,
}) => {
  const stripePromise = loadStripe(process.env.GATSBY_STRIPE_PUBLIC_KEY ?? '');

  return (
    <StripeProvider stripe={stripePromise}>
      <ChangePaymentForm account={account} loading={loading} />
    </StripeProvider>
  );
};

export default ChangePaymentInfo;
